import * as React from "react";
const SvgFiRrHr = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-hr_svg__a)">
      <path d="M14 6c0-3.309-2.691-6-6-6S2 2.691 2 6s2.691 6 6 6 6-2.691 6-6m-6 4c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m-1.042 5.005a1 1 0 0 1-.673 1.244C3.762 16.999 2 19.365 2 22v1a1 1 0 0 1-2 0v-1c0-3.514 2.35-6.667 5.715-7.668a1 1 0 0 1 1.243.673M19.5 17.4h-.9v-1.8h.9c.496 0 .9.404.9.9s-.404.9-.9.9M24 15v6a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3m-8.8-1a.8.8 0 0 0-.8.8v2.395h-1.8V14.8a.8.8 0 1 0-1.6 0v6.4a.8.8 0 1 0 1.6 0v-2.405h1.8V21.2a.8.8 0 1 0 1.6 0v-6.4a.8.8 0 0 0-.8-.8m5.733 4.544a2.49 2.49 0 0 0 1.047-2.362C21.822 14.908 20.65 14 19.367 14H17.8a.8.8 0 0 0-.8.8v6.4a.8.8 0 1 0 1.6 0V19h.784l.705 2.423a.8.8 0 0 0 .768.577h.063a.8.8 0 0 0 .765-1.033l-.739-2.43.042-.029c-.019.012-.031.021-.055.035z" />
    </g>
    <defs>
      <clipPath id="fi-rr-hr_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHr;
